'use strict';

/**
 * @typedef {Object} UserService
 * @property { (function(userId: string): Promise) } lockoutUser
 * @property { (function(userId: string): Promise) } unlockUser
 */
/**
 * @ngdoc service
 * @name gfcmsApp.user.service
 * @description
 * # user.service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .service('userService', function(BaseService, $q) {

    var service = new BaseService();

    service.changePassword = changePassword;
    service.GetAll = GetAll;
    service.GetById = GetById;
    service.getRoles = getRoles;
    service.GetByUsername = GetByUsername;
    service.getUserActivityLogs = getUserActivityLogs;
    service.createUser = createUser;
    service.Update = Update;
    service.lockoutUser = lockoutUser;
    service.unlockUser = unlockUser;

    return service;

    function GetAll() {
      return service.http.get(service.baseUrl + '/users')
        .then(service.handleSuccess)
        .catch(service.handleError);
    }

    function GetById(id) {
      return service.http.get(service.baseUrl + '/users/' + id)
      .then(service.handleSuccess)
      .catch(service.handleError);
    }

    function GetByUsername(username) {
      return service.http.get(service.baseUrl + '/users/' + username)
      .then(service.handleSuccess)
      .catch(service.handleError);
    }

    function createUser(user) {
      return service.http.post(service.baseUrl + '/account/register', user)
      .then(service.handleSuccess)
      .catch(service.handleError);
    }

    function Update(user) {
      return service.http.put(service.baseUrl + '/users/' + user.id, user)
      .then(service.handleSuccess)
      .catch(service.handleError);
    }

    function changePassword(userId, changePasswordData) {
      if (!userId) {
        return changeUserPassword(changePasswordData);
      }

      return service.http.post(service.baseUrl + '/users/' + userId + '/changepassword', changePasswordData)
      .then(service.handleSuccess)
      .catch(service.handleError);
    }

    function changeUserPassword(changePasswordData) {
      return service.http.post(service.baseUrl + '/account/changepassword', changePasswordData)
      .then(service.handleSuccess)
      .catch(service.handleError);
    }

    function getRoles() {
      return service.http.get(service.baseUrl + '/roles/')
      .then(service.handleSuccess)
      .catch(service.handleError);
    }

    function getUserActivityLogs(userId) {
      return service.http.get(service.baseUrl + '/activitylogs/' + userId)
      .then(service.handleSuccess)
      .catch(service.handleError);
    }

    function lockoutUser(userId) {
      return service.http.post(`${service.baseUrl}/users/${userId}/lockout`)
      .then(service.handleSuccess)
      .catch(service.handleError);
    }

    function unlockUser(userId) {
      return service.http.post(`${service.baseUrl}/users/${userId}/unlock`)
      .then(service.handleSuccess)
      .catch(service.handleError);
    }
  });
